import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-custom-form-label',
  templateUrl: './form-label.component.html',
  styleUrls: ['./form-label.component.scss'],
})
export class FormLabelComponent {
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() toolTip: string = '';
  @Input() labelClass: string = '';
  @Input() showInfoAsTooltip: boolean = true;
  @Input() link: string;
  @Input() customIcon: {
    icon: string;
    pack?: string;
    class?: string;
    status?: string;
  };
  @Output() customIconClickEvent = new EventEmitter();

  constructor() {}

  openLinkInNewTab() {
    if (!this.link?.length) {
      return;
    }
    window.open(this.link, '_blank');
  }

  customIconClick(event) {
    this.customIconClickEvent.emit(event);
  }
}
